// components/ManagerSummarySection/ManagerSummarySection.js
import React from "react";
import { Box } from "@material-ui/core";
import ManagerSummaryCard from "components/ManagerSummaryCard/ManagerSummaryCard";
import useDashboardSummary from "hooks/useDashboardSummary";
import {
    Store as StoreIcon,
    Archive as ArchiveIcon,
    ShoppingCart as ShoppingCartIcon,
    Payment as PaymentIcon,
} from "components/MaterialSymbol/MaterialIcons";

const summaryIconStyle = {
    fontSize: 30,
    fontVariationSettings: '"FILL" 0, "wght" 100, "GRAD" 0, "opsz" 24',
};
const summaryProgressColor = "#111827";

export default function ManagerSummarySection({ subscriptionPlanId = "" }) {
    const { summary, isLoading } = useDashboardSummary(subscriptionPlanId);

    const activeStores = summary?.activeStores || 0;
    const archivedStores = summary?.archivedStores || 0;
    const totalOrders = summary?.totalOrders || 0;
    const totalTransactions = summary?.totalTransactions || 0;

    return (
        <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fit, minmax(260px, 1fr))"
            gridGap="24px"
            width="100%"
            p={1}
            mb={3}
        >
            <ManagerSummaryCard
                icon={<StoreIcon style={summaryIconStyle} />}
                value={isLoading ? "Loading..." : activeStores}
                label="Active Stores"
                progressColor={summaryProgressColor}
                progressValue={75}
            />
            <ManagerSummaryCard
                icon={<ArchiveIcon style={summaryIconStyle} />}
                value={isLoading ? "Loading..." : archivedStores}
                label="Archived Stores"
                progressColor={summaryProgressColor}
                progressValue={50}
            />
            <ManagerSummaryCard
                icon={<ShoppingCartIcon style={summaryIconStyle} />}
                value={isLoading ? "Loading..." : totalOrders}
                label="Total Orders"
                progressColor={summaryProgressColor}
                progressValue={65}
            />
            <ManagerSummaryCard
                icon={<PaymentIcon style={summaryIconStyle} />}
                value={isLoading ? "Loading..." : `$${totalTransactions.toLocaleString()}`}
                label="Total Transactions"
                progressColor={summaryProgressColor}
                progressValue={80}
            />
        </Box>
    );
}
